import { createSlice } from '@reduxjs/toolkit';

let startDate = new Date();
startDate.setMonth(startDate.getMonth()-1);

let endDate = new Date();

const initialState = {
  date: localStorage.getItem('date')
    ? JSON.parse(localStorage.getItem('date'))
    : {startDate: startDate.toISOString(), endDate: endDate.toISOString()},
};

const dateSlice = createSlice({
  name: 'date',
  initialState,
  reducers: {
    setDate: (state, action) => {
      state.date = action.payload;
      localStorage.setItem('date', JSON.stringify(action.payload));
    },
  },
});

export const { setDate } = dateSlice.actions;

export default dateSlice.reducer;
